import EventBus from '../../../../shared/js/wirebox/event-bus'
import jQuery from 'jquery'
import {default as Bookmarks} from './bookmarks'
import Archive from '../archive'
import './bookmark-btn'

class TrainingList extends Archive {
    
    /**
     * Construct component
     * @param container
    */
    constructor(container) {
        
        super({
            container: container,
            countText: jQuery('#training-count'),
            descending: false,
            filterForm: jQuery('#training-filters'),
            key: 'training-list',
            template: jQuery('#training-template'),
            updatedTime: container.data('updated-time')
        })
        
        /**
         * Icon URL
         * @type string
        */
        this.iconUrl = this.container.data('icon-url')
        
        /**
         * Show URL
         * @type string
        */
        this.showUrl = this.container.data('show-url')
        
        this.bindEvents()
        
    }
    
    /**
     * Render Training
     * @param items
    */
    renderItems(items) {
        
        let
            elem,
            url,
            dateFrom,
            dateTo,
            dateText,
            bookmark
            
        const now = Date.now()
        
        //Loop through Training
        jQuery.each(items, (i, course) => {
            
            elem = jQuery(this.templateHtml)
            
            //Apply title
            elem.find('.training-title').text(course.name)
            
            //Apply thumbnail
            if (course.thumbnail) {
                elem.find('.training-img').attr('src', ('/storage/' + course.thumbnail))
            }
            
            //Apply description
            elem.find('.training-description').html(course.description + (course.description.slice(-1) == '.' ? '' : '...'))
            
            //Apply cost
            if (course.cost) {
                elem.find('.cost').html(course.cost)
            }
            else {
                elem.find('.cost').hide()
            }
            
            //Apply duration
            if (course.duration) {
                elem.find('.duration').text(course.duration)
            }
            else {
                elem.find('.duration').hide()
            }
            
            //Apply format
            if (course.format) {
                elem.find('.format').text(formats.hasOwnProperty(course.format) ? formats[course.format] : course.format)
            }
            else {
                elem.find('.format').hide()
            }
            
            //Apply dates
            dateFrom = course.date_from ? (new Date(course.date_from)) : null
            dateTo = course.date_to ? (new Date(course.date_to)) : null
            dateText = (dateFrom && now >= dateFrom && dateTo && now <= dateTo) ? 'Available Now' : ((dateFrom && dateTo) ? (dateFrom.toLocaleDateString('en-GB') + ' - '  + dateTo.toLocaleDateString('en-GB')) : 'Ongoing')
            elem.find('.training-dates').text(dateText)
            
            //Apply theme
            if (course.theme) {
                elem.find('.training-theme').css('background-image', 'url("' + this.iconUrl.replace('-1', course.theme) + '")')
            }
            else {
                elem.find('.training-theme').hide()
            }
            
            //Apply slug to bookmark button
            bookmark = elem.find('.bookmark')
            if (bookmark.length > 0) {
                
                bookmark.data('slug', course.slug)
                
                EventBus.publish('training.bookmark.update', {
                    bookmarked: Bookmarks.has(course.id),
                    element: bookmark
                })
                
            }
            
            //Apply hyperlink
            elem.find('.training-col').attr('href', this.showUrl.replace('-1', course.slug))
            
            //Append element to archive
            this.container.append(elem)
            
        })
        
    }
    
    /**
     * Bind events
    */
    bindEvents() {
        
        //Bind map created event
        EventBus.subscribe('run-modules', this.run.bind(this))
        
        //Bind filter form submit event
        this.filterForm.submit(this.handleFilters.bind(this))
        
        //Bind filter events
        this.bindFilterEvents()
        
    }
    
}

EventBus.subscribe('init-modules',  () => {
    
    const container = jQuery('#training-list')
    
    if (container.length > 0) {
        new TrainingList(container)
    }
    
})

export default TrainingList